export const getQueryParams = (): Record<string, unknown> => {
  return Object.fromEntries(new URLSearchParams(window.location.search))
}

export const getQueryParamsFromString = (urlLikeString: string): Record<string, unknown> => {
  return Object.fromEntries(new URLSearchParams(urlLikeString.split('?')[1]))
}
